// extracted by mini-css-extract-plugin
module.exports = {"bio":"Designer_bio__8hd9S","image":"Designer_image__3JkRz","description":"Designer_description__wB4G3"};